import { AnalysisStoreProvider } from '@modules/analysis/store/AnalysisStoreProvider';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import { QuantifyStoreProvider } from '@modules/quantify/store/QuantifyStoreProvider';
import { getQuantifyQueryRetentionKey } from '@modules/quantify/utils';
import { Box } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';
import { useEffect } from 'react';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { QueryStatus } from 'v2/core/repository/edge-server/types';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { useGetUser } from 'v2/core/services/user';
import { NewQuantifyAnalysis } from '../NewQuantifyAnalysis';
import { SavedQuantifyAnalysisIndex } from '../SavedQuantifyAnalysis';

export function QuantifyAnalysisContainer() {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const { token } = useParseSavedSlugInfo();
  const { data: sourceDetailsMap, status } = useGetSourceDetailsMap();

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem(getQuantifyQueryRetentionKey(tenantSlug));
    };
  }, [tenantSlug]);

  if (!sourceDetailsMap || status === QueryStatus.IN_PROGRESS) {
    return (
      <Box height="100vh">
        <CircularLoader />
      </Box>
    );
  }

  if (token) {
    return <SavedQuantifyAnalysisIndex key="saved-analysis-v2" />;
  }

  return (
    <AnalysisStoreProvider
      key="unsaved-analysis-v2"
      useCase={AnalysisUseCase.Default}
    >
      <QuantifyStoreProvider>
        <NewQuantifyAnalysis />
      </QuantifyStoreProvider>
    </AnalysisStoreProvider>
  );
}
